import React from 'react';
import { withTranslation } from 'react-i18next';
import { Form, FormGroup, CustomInput } from 'reactstrap';
import { Formik, FieldArray } from 'formik';
import Backend from '../../../../Layouts/Backend';
import { Alert, Button, Input } from '../../../../UI/Common';
import validationSchema from '../validation';
import ProcessForm from './ProcessForm';

function NewBatchReportPage({ t, ...props }) {
  const processForm = {
    process: '',
    beginTime: new Date(),
    endTime: new Date(),
    additional: '',
    filler: null,
  };
  const form = {
    batchNumber: '',
    productName: '',
    printCharts: true,
    printNotes: true,
    printLimitChanges: true,
    printApproval: true,
    containsNames: false,
    additionalField: '',
    daysSave: '',
    comments: '',
    processes: [Object.assign({}, processForm)],
  };
  function addProcessForm(fieldArrProps, processesArr) {
    if (processesArr.length + 1 <= 4) {
      fieldArrProps.push(processForm);
    }
  }
  return (
    <Backend title={`New Batch Report for Department: ${props.title}`}>
      <div className="content-inner">
        <Formik
          initialValues={form}
          validationSchema={validationSchema}
          onSubmit={(values) => props.onCreateBatch(values)}
        >
          {({
            values,
            handleChange,
            errors,
            setFieldValue,
            touched,
            handleSubmit,
          }) => {
            return (
              <Form>
                <div className="w-50">
                  <Input
                    required
                    id="batchNumber"
                    label="Batch Number"
                    onChange={handleChange('batchNumber')}
                    value={values.batchNumber}
                    invalid={touched.batchNumber}
                    error={errors.batchNumber}
                  />
                  <Input
                    id="productName"
                    label="Product Name"
                    onChange={handleChange('productName')}
                    value={values.productName}
                    invalid={touched.productName}
                    error={errors.productName}
                  />
                  <FormGroup>
                    <CustomInput
                      type="checkbox"
                      id="printCharts"
                      checked={values.printCharts}
                      label="Print Charts"
                      onChange={(e) =>
                        setFieldValue('printCharts', e.target.checked)
                      }
                    />
                    <CustomInput
                      type="checkbox"
                      id="printNotes"
                      checked={values.printNotes}
                      label="Print Notes"
                      onChange={(e) =>
                        setFieldValue('printNotes', e.target.checked)
                      }
                    />
                    <CustomInput
                      type="checkbox"
                      id="printLimitChanges"
                      checked={values.printLimitChanges}
                      label="Print Limit Changes"
                      onChange={(e) =>
                        setFieldValue('printLimitChanges', e.target.checked)
                      }
                    />
                    <CustomInput
                      type="checkbox"
                      id="printApproval"
                      checked={values.printApproval}
                      label="Print Approval"
                      onChange={(e) =>
                        setFieldValue('printApproval', e.target.checked)
                      }
                    />
                    <CustomInput
                      type="checkbox"
                      id="containsNames"
                      checked={values.containsNames}
                      label="Contains Names"
                      onChange={(e) =>
                        setFieldValue('containsNames', e.target.checked)
                      }
                    />
                  </FormGroup>
                  {!values.containsNames && (
                    <Input
                      id="additionalField"
                      label="Additional Field"
                      onChange={handleChange('additionalField')}
                      value={values.additionalField}
                      invalid={touched.additionalField}
                      error={errors.additionalField}
                    />
                  )}
                  <Input
                    required
                    id="daysSave"
                    label="Days to Save"
                    onChange={handleChange('daysSave')}
                    value={values.daysSave}
                    invalid={touched.daysSave}
                    error={errors.daysSave}
                  />
                  <Input
                    type="textarea"
                    id="comments"
                    label="Comments"
                    onChange={handleChange('comments')}
                    value={values.comments}
                    invalid={touched.comments}
                    error={errors.comments}
                  />
                </div>

                <FieldArray name="processes">
                  {(fieldArrProps) => {
                    return (
                      <div style={{ marginTop: 15 }}>
                        <div className="d-flex justify-content-between align-items-baseline">
                          <h4 className="mb-0">Processes</h4>
                          <a
                            onClick={() => {
                              addProcessForm(fieldArrProps, values.processes);
                            }}
                            className="abutton"
                            style={{
                              cursor:
                                values.processes.length === 4
                                  ? 'not-allowed'
                                  : 'pointer',
                            }}
                          >
                            Add Aditional Process
                          </a>
                        </div>
                        <hr />
                        {touched.processes &&
                        errors.processes &&
                        errors.processes === 'process_length' ? (
                          <span style={{ color: '#dc3545' }}>
                            {t('Batch report requires at least 1 proccess')}
                          </span>
                        ) : null}
                        {values.processes.length
                          ? values.processes.map((processEntity, index) => {
                              return (
                                <ProcessForm
                                  key={index}
                                  index={index}
                                  prefix="processes"
                                  values={processEntity}
                                  containsNames={values.containsNames}
                                  additionalField={values.additionalField}
                                  users={props.users}
                                  groups={props.groups}
                                  setFieldValue={setFieldValue}
                                  handleChange={handleChange}
                                  touched={touched}
                                  errors={errors}
                                  remove={fieldArrProps.remove}
                                />
                              );
                            })
                          : null}
                      </div>
                    );
                  }}
                </FieldArray>

                <Alert.Error text={props.errors} />
                <Button
                  id="create-batch-report"
                  loading={props.isSubmitting}
                  onClick={handleSubmit}
                >
                  <i className="md-icon">done</i>
                  {t('Create')}
                </Button>
              </Form>
            );
          }}
        </Formik>
      </div>
    </Backend>
  );
}

export default withTranslation('app')(NewBatchReportPage);
